import { core } from '../core/index.js';

export type FabricToastCloseIndicatorApi = () => void;

/**
 * 关闭全屏幕 Native Indicator 动画.
 * 默认当webview初始化页面的时候会显示加载器动画, 资源加载完毕自动关闭动画.
 * 但当URL协议有`ntv_indicator`参数的时候默认的载入webview的资源进度加载器不会自动关闭.需要调用此方法去关闭.
 * Note: 针对Android, 如果使用硬件back按钮, 点击back键是否连同当前webview一起关闭.
 */
export const closeIndicator = () => {
  core.call<'fabric_toast.closeIndicator'>('fabric_toast.closeIndicator');
};
